export class PredefinedMessagePlaceholderModel {
  _id?: any;
  uuid: string;
  predefined_message_uuid: string;
  predefined_message_line_uuid: string;
  create_date: Date;
  update_date: Date;
  created_by: string;
  updated_by: string;
  status: string;
  revision: string;
  vrsn?: string;
  placeholder_name?: string;
  placeholder_code?: string;
  placeholder_type?: string;
  placeholder_source?: string;
  placeholder_data_type?: string;
  default_value?: string;
  value_string?: string;
  value_file?: string;
  value_numeric?: number;
  value_datetime?: Date;
  value_json?: object;
  index?: number;
}

export class PredefinedMessagePlaceholderModelSerializer {
  static fromJson(json: any): PredefinedMessagePlaceholderModel {
    const model = new PredefinedMessagePlaceholderModel();
    model.uuid = json.guid;
    model.predefined_message_uuid = json.template_message_hdr_guid;
    model.predefined_message_line_uuid = json.template_message_line_guid;
    model.create_date = new Date(json.created_date);
    model.update_date = new Date(json.updated_date);
    model.created_by = json.created_by_subject_guid;
    model.updated_by = json.updated_by_subject_guid;
    model.status = json.status;
    model.revision = json.revision;
    model.placeholder_name = json.placeholder_name;
    model.placeholder_code = json.placeholder_code;
    model.placeholder_type = json.placeholder_type;
    model.placeholder_source = json.placeholder_source;
    model.placeholder_data_type = json.placeholder_data_type;
    model.default_value = json.default_value;
    model.value_string = json.value_string;
    model.value_file = json.value_file;
    model.value_numeric = json.value_numeric;
    model.value_datetime = json.value_datetime
      ? new Date(json.value_datetime)
      : null;
    model.value_json = json.value_json;
    model.index = json.index;
    return model;
  }
}
